import { ComparisonTableAction } from "../comparison_table/comparison_table_action";
import { Analytics } from "./analytics";

export class ComparisonTableAddAnalytics extends Analytics {

  constructor() {
    super();
    ComparisonTableAction.ADD_COMPARISON_EVENT.on((data) => {
      this.run(() => {
        const fName = '比較表に追加';
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: fName,
          club: {
            server: 'club/pc',
            prop5: fName,
          },
        }
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }
}
